import {
  START_LOADING,
  STOP_LOADING,
  SHOW_ALERT,
  FETCH_SERVICE_CENTERS_BY_ORG_SUCCESS,
  FETCH_SERVICE_CENTERS_BY_ORG_FAILURE,
  FETCH_SERVICE_CENTER_FAILURE,
  FETCH_SERVICE_CENTER_SUCCESS,
  FETCH_SERVICE_CENTERS_FAILURE,
  FETCH_SERVICE_CENTERS_SUCCESS,
} from "../actionConstants";
import { AppDispatch } from "../store";
import { get, post } from "./axios";

export const createServiceCenter =
  (data: any) => async (dispatch: AppDispatch) => {
    dispatch({
      type: START_LOADING,
      payload: { message: "Creating service center..." },
    });
    try {
      const response = await post("/global-services/create", data, dispatch);
      dispatch({
        type: SHOW_ALERT,
        payload: {
          message: "Service center created successfully!",
          type: "success",
        },
      });
    } catch (error: any) {
      dispatch({
        type: SHOW_ALERT,
        payload: {
          message: error?.response?.data?.message || error.message,
          type: "error",
        },
      });
    }
    dispatch({ type: STOP_LOADING });
  };

// Action to fetch all service centers
export const fetchAllServiceCenters = () => async (dispatch: AppDispatch) => {
  dispatch({
    type: START_LOADING,
    payload: { message: "Loading service centers..." },
  });
  try {
    const response = await get("/global-services/all", {}, dispatch);
    dispatch({ type: FETCH_SERVICE_CENTERS_SUCCESS, payload: response });
  } catch (error: any) {
    dispatch({
      type: SHOW_ALERT,
      payload: { message: error.message, type: "error" },
    });
    dispatch({ type: FETCH_SERVICE_CENTERS_FAILURE, payload: error.message });
  }
  dispatch({ type: STOP_LOADING });
};

export const getAllServiceCenters =
  (queryData?: any) => async (dispatch: AppDispatch) => {
    const searchParams = new URLSearchParams(queryData);
    try {
      dispatch({ type: START_LOADING });
      const result = await get(
        `/global-services/paginated?${searchParams}`,
        {},
        dispatch
      );
      dispatch({
        type: FETCH_SERVICE_CENTERS_SUCCESS,
        payload: result,
      });
    } catch (err) {
      //
      dispatch({
        type: FETCH_SERVICE_CENTERS_FAILURE,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };

// Action to fetch a single service center by ID
export const fetchServiceCenterById =
  (id: number) => async (dispatch: AppDispatch) => {
    dispatch({
      type: START_LOADING,
      payload: { message: "Loading service center..." },
    });
    try {
      const response = await get(
        `/global-services/getById/${id}`,
        {},
        dispatch
      );
      dispatch({
        type: FETCH_SERVICE_CENTER_SUCCESS,
        payload: response,
      });
    } catch (error: any) {
      dispatch({
        type: SHOW_ALERT,
        payload: { message: error.message, type: "error" },
      });
      dispatch({
        type: FETCH_SERVICE_CENTER_FAILURE,
        payload: error.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };

// Action to fetch service centers by orgId
export const fetchServiceCentersByOrgId =
  (orgId: any) => async (dispatch: AppDispatch) => {
    dispatch({
      type: START_LOADING,
      payload: { message: "Loading organization service centers..." },
    });
    try {
      const response = await get(
        `/global-services/getByOrgId/${orgId}`,
        {},
        dispatch
      );
      dispatch({
        type: FETCH_SERVICE_CENTERS_BY_ORG_SUCCESS,
        payload: response,
      });
    } catch (error: any) {
      dispatch({
        type: SHOW_ALERT,
        payload: { message: error.message, type: "error" },
      });
      dispatch({
        type: FETCH_SERVICE_CENTERS_BY_ORG_FAILURE,
        payload: error.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
